import React from 'react'

import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
function TipogramAchiverBadge() {
  return (
    <>
    <EmojiEventsIcon className='featuredArtistsBadgeIcon featuredArtistsBadgeEmoji'/>
    </>
  )
}

export default TipogramAchiverBadge